// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__ICY59","controls":"styles_controls__2s80m","select":"styles_select__3oxLW","text":"styles_text__y-hJU"};